import type { ActivityType } from "@opensea/graphql"
import { z } from "zod"

export const ACTIVITY_TYPES_COOKIE_NAME = "activityTypes"
export const SECONDARY_ACTIVITY_TYPES_COOKIE_NAME = "secondaryActivityTypes"
const ACTIVITY_TYPES = [
  "SALE",
  "MINT",
  "TRANSFER",
  "LISTING",
  "OFFER",
  "COLLECTION_OFFER",
  "TRAIT_OFFER",
] as const satisfies ActivityType[]
export const FALLBACK_ACTIVITY_TYPES = [
  "SALE",
  "MINT",
] as const satisfies ActivityType[]

export const activityTypesSchema = z
  .array(z.enum(ACTIVITY_TYPES))
  .optional()
  .catch(undefined)

export function parseActivityTypes(
  activityTypes: string | undefined,
): ActivityType[] | undefined {
  if (!activityTypes) {
    return undefined
  }

  const parsed = JSON.parse(activityTypes) as unknown
  const result = activityTypesSchema.safeParse(parsed)

  if (!result.success || (result.data && result.data.length === 0)) {
    return undefined
  }

  return result.data
}
